module.exports = __webpack_public_path__ + "static/media/454.cc3eaf55.webp";